import { extendOptions } from './default-options';

const INTERPOLATION_PATTERN = /\{\{(\w+)\}\}/gi;

class Endpoint {
  constructor(service, method, url, options = {}) {
    this.service = service;
    this.method = method;
    this.url = url;
    this.options = options;
  }
  extendOptions(options) {
    extendOptions(this.options, options);
  }
  getUrl(urlParams = {}) {
    var url = this.url.replace(INTERPOLATION_PATTERN, function(match, p1) {
      return urlParams.hasOwnProperty(p1) ? urlParams[p1] : match;
    });
    return url;
  }
  getFullUrl(urlParams = {}) {
    return this.service.apiUrl + this.getUrl(urlParams);
  }
  execute(data, urlParams) {
    var { service } = this;

    var url = this.getUrl(urlParams);

    var response;
    switch (this.method) {
      case 'get':
        response = service.get(url, data, this.options);
        break;
      case 'delete':
        response = service.delete(url, data, this.options);
        break;
      case 'patch':
        response = service.patch(url, data, this.options);
        break;
      case 'post':
        response = service.post(url, data, this.options);
        break;
      case 'put':
        response = service.put(url, data, this.options);
        break;
    }

    return response;
  }
}

export default Endpoint;
